import { render, staticRenderFns } from "./Show_.vue?vue&type=template&id=94c888de&scoped=true&"
import script from "./Show_.vue?vue&type=script&lang=js&"
export * from "./Show_.vue?vue&type=script&lang=js&"
import style0 from "./Show_.vue?vue&type=style&index=0&id=94c888de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c888de",
  null
  
)

export default component.exports